import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import { UIKind } from "../../../define/UIKind";
import weChatPrefab from "../../../spendMode/prefab/weChatPrefab/weChatPrefab";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab } from "../../BundleResourceConfig";
import { getOneNormalEventNewById } from "../../config/normalEvent_NewConfig";
import { getOneHeadUrlById } from "../../config/UserHeadConfig";
import { getOneChitAryById } from "../../config/WeChatChitChatConfig";
import { getOnePeopleById } from "../../config/WeChatPeopleConfig";
import { AccountItem } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import { WeChatChitChat, WeChatChitChatChoose, WeChatChitChatMap, WeChatChitChatMapMap, WeChatEvent, WeChatLink, WeChatLinkChats, WeChatManagerPeople, WeChatSaveChat} from "../../manager/WeChatConst";
import UserDataManage from "../../model/UserDataManage";
import WeChatResultNode from "./WeChatResultNode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class WeChatFrame extends cc.Component {

    chitChatAry:WeChatChitChat[] = null;

    chitChatMap:WeChatChitChatMap = {};
    chitChatMapMap: WeChatChitChatMapMap = {};

    @property(cc.Node)
    nodeNoChat: cc.Node = null;
    @property(cc.Node)
    nodeChatSelect: cc.Node = null;

    @property({type:cc.Prefab,displayName:"自己说话预制体"})
    meAskPrefab:cc.Prefab = null;

    @property({type:cc.Prefab,displayName:"其他说话预制体"})
    otherAskPrefab:cc.Prefab = null;

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    @property({type:cc.Node,displayName:"选项节点"})
    chooseNode:cc.Node = null;

    @property({type:cc.Node,displayName:""})
    resultNode:cc.Node = null;

    @property({type:cc.ScrollView,displayName:"滚动条"})
    chatScroll:cc.ScrollView = null;

    @property({type:cc.Label,displayName:"聊天顶部文本"})
    lb_Top:cc.Label = null;

    spriteMap = {};

    nextId:string = null;

    weChatLink:WeChatLink = null;

    lastWeChatChitChatChoose:WeChatChitChatChoose = null;

    oldChoose:WeChatSaveChat[] = [];

    currentChoose:WeChatSaveChat[] = [];

    currentChitChats:WeChatChitChat[] = [];

    currentChitChat:WeChatChitChat = null;

    lastChooseIndex:number = 0;

    // mainItem:WeChatMainItem = null;

    people:WeChatManagerPeople = null;

    complete?:()=>void;

    @property({type:cc.Node,displayName:"返回按钮"})
    btn_Back:cc.Node = null;

    @property({type:cc.Node,displayName:"跳过按钮"})
    btn_Jump:cc.Node = null;

    @property({type:cc.Node,displayName:"钱节点"})
    coinNode:cc.Node = null;

    @property({type:cc.Node,displayName:"时间节点"})
    timeNode:cc.Node = null;

    @property({type:cc.Node,displayName:"爱情屋结果页面"})
    congratulationNode:cc.Node = null;

    isStart:boolean = false;

    private chitChatId: string = null;

    bindData(chitChatId: string,oldChoose:WeChatSaveChat[] = [],people:WeChatManagerPeople,complete?:()=>void,isStart:boolean = false){
        this.chitChatId = chitChatId;
        this.people = people;
       
        // this.mainItem = mainitem;
        let chitChatAry: WeChatChitChat[] = [];
        let chatIdT = chitChatId;
        if(chitChatId){
            let chitChat = this.weChatLink = getOneChitAryById(chitChatId);
            chitChatAry = chitChat.chats;
            this.chitChatAry = chitChatAry.concat();
        } else {
            if (oldChoose && oldChoose.length > 0) {
                let lastId = oldChoose[oldChoose.length-1].chatsId;
                chatIdT = lastId;
                chitChatAry = getOneChitAryById(lastId).chats;
            }
        }
        for(let i =0;i<chitChatAry.length;i++){
            let chitChat = chitChatAry[i];
            this.chitChatMap[chitChat.id] = chitChat;
        }
        this.chitChatMapMap[chatIdT] = this.chitChatMap;
        // O1HD.getServices().miniGameSrv.getAppApiInstance().gameRecordStart({duration:300});
        this.oldChoose = oldChoose.concat();
        this.complete = complete;
        let p = getOnePeopleById(this.people.peopleId);
        this.lb_Top.string = p.name;
        if(isStart){
            this.btn_Back.active = false;
            this.btn_Jump.active = true;
            // this.coinNode.active = false;
            // this.timeNode.active = false;
        }else{
            this.btn_Back.active = true;
            this.btn_Jump.active = false;
            // this.coinNode.active = true;
            // this.timeNode.active = true;
        }
        this.isStart = isStart;
    }

    async loadSprites(){

        let self = this;
        return new Promise<void>(resolve=>{
            if (!self.node || !cc.isValid(self.node)) {
                resolve();
                console.error('wechatframe loadSprites 已被销毁');
                return;
            }

            let gameManager = NormalGameManager._instance;
            let meHead = "res/user/head/" + getOneHeadUrlById(NormalGameManager._instance.getGameData().userCurrHead);
            O1HD.getManagers().gameMgr.getCurrMode().bundle.load(meHead,cc.SpriteFrame,(err,imgs:cc.SpriteFrame)=>{
                if(err){
                    console.log(err);
                }else{
                    self.spriteMap[meHead] = imgs;
                }
            });
            let imgUrls:string[] = [];
            if(self.chitChatAry){
                for( let i =0; i<self.chitChatAry.length;i++){
                    let chitChat = self.chitChatAry[i];
                    // console.log(chitChat,this.chitChatAry);
                    let peopleId = chitChat.peopleId;
                    let people = getOnePeopleById(peopleId);
                    let headUrl = people.headUrl;
                    if(!imgUrls.includes(headUrl)){
                        imgUrls.push(headUrl);
                    }
                    let chooses = chitChat.chooses;
                    for(let i = 0;i<chooses.length;i++){
                        let chat = chooses[i].chat;
                        if(chat.includes("图片：")){
                            let url = "weChatSprite/" + chat.substring(3);
                            if(!imgUrls.includes(url)){
                                imgUrls.push(url);
                            }
                        }
                    }
                }
            }
            for(let i =0;i<self.oldChoose.length;i++){
                let oldData = self.oldChoose[i];
                let people = getOnePeopleById(oldData.peopleId);
                let url = people.headUrl;
                if(!imgUrls.includes(url)){
                    imgUrls.push(url);
                }
                
                if (!self.chitChatMapMap[oldData.chatsId]) {
                    self.addChatMap(oldData.chatsId);
                }
                if (!self.chitChatMapMap || !self.chitChatMapMap[oldData.chatsId]) {
                    console.error(`未找到chitChatMapMap数据 id = ${oldData.chatsId}`,oldData);
                    continue;
                }
                let chatLink = self.chitChatMapMap[oldData.chatsId][oldData.chatId];

                if (!chatLink) {
                    console.error(`未找到旧的数据 chatLink`)
                    continue;
                }
                // let chatLink = this.chitChatMap[oldData.chatId];
                let chat = chatLink.chooses[oldData.chatChoose].chat;
                if(chat.includes("图片：")){
                    let img = "weChatSprite/" + chat.substring(3);
                    if(!imgUrls.includes(img)){
                        imgUrls.push(img);
                    }
                }
            }
            // console.log(imgUrls);
            if(imgUrls.length > 0){
                getOneBundleByInstant(BUNDLE_SMALL_NAME.WeChatGameBundle).load(imgUrls,cc.SpriteFrame,(err,imgs:cc.SpriteFrame[])=>{
                    if(err){
                        console.log(err);
                    }else{
                        for(let i =0;i<imgs.length;i++){
                            self.spriteMap[imgUrls[i]] = imgs[i];
                        }
                        // console.log(this.spriteMap);
                    }
                    resolve();
                });
            }else{
                resolve();
            }
        });
    }

    addChatMap(chatId: string) {
        let chitChat = getOneChitAryById(chatId);
        let chitChatAry = chitChat.chats;

        let chitChatMap: WeChatChitChatMap = {};
        for(let i =0;i<chitChatAry.length;i++){
            let chitChat = chitChatAry[i];
            chitChatMap[chitChat.id] = chitChat;
        }
        this.chitChatMapMap[chatId] = chitChatMap;
    }

    async start(){

        this.nodeNoChat.active = false;
        this.nodeChatSelect.active = false;

        this.itemContent.destroyAllChildren();
        this.itemContent.removeAllChildren();

        await this.loadSprites();
        if(this.oldChoose.length > 0){
            await this.loadFrame();
        }

        if (!this.chitChatAry || this.chitChatAry.length <= 0) {
            this.nodeNoChat.active = true;
        } else {
            this.nodeChatSelect.active = true;
            this.startChat();
        }

        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.WE_CHAT_FRAME);
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.WE_CHAT_FRAME);
    }

    startChat(){
        this.currentChoose = [];
        this.nextId = null;
        this.lastChooseIndex = 0;
        this.currentChitChats = [];
        this.currentChitChat = null;
        
        if(!this.people.bNewChat && this.oldChoose.length > 0){
            let oldData = this.oldChoose[this.oldChoose.length-1];
            let chatId = Number(oldData.chatId);
            let chitChat = this.chitChatMap[chatId];
            this.nextId = chitChat.chooses[oldData.chatChoose].param["nextId"];
        } else {
            this.nextId = this.chitChatAry[0].id;
        }
        
        this.scheduleOnce(()=>{
            this.showChooses();
            // this.onChat(oneChitChat);
        });
    }

    onChat(chitChat:WeChatChitChat,chooseIndex:number = 0){
        this.currentChitChat = chitChat;
        let choose = chitChat.chooses[chooseIndex];
        this.lastWeChatChitChatChoose = choose;
        let peopleId = chitChat.peopleId;
        switch(peopleId){
            case "自己":{
                let isTrue = this.onMeChat(choose, chooseIndex);
                if(isTrue){
                    O1HD.getManagers().soundMgr.playSound("weChatSendMessage");
                    this.currentChitChats.push(chitChat);
                    let nextId = choose.param["nextId"];
                    if(nextId != null){
                        // 下一条消息
                        this.nextId = nextId;
                    }else{
                        this.nextId = null;
                    }
                    return true;
                }
                return false;
                break;
            }
            default:{
                this.onOtherChat(chitChat, chooseIndex);
                O1HD.getManagers().soundMgr.playSound("weChatNewMessage");
                this.currentChitChats.push(chitChat);
                let nextId = choose.param["nextId"];
                if(nextId != null){
                    // 下一条消息
                    this.nextId = nextId;
                }else{
                    this.nextId = null;
                }
                return true;
                break;
            }
        }
    }

    onMeChat(choose:WeChatChitChatChoose, chooseIndex: number){

        let chat:string = choose.chat;
        if(chat.includes("红包：")  || chat.includes("转账：")){

            let moneyNum:number = Number(chat.substring(3));
            if(O1HD.getServices().userSrv.getCoins() < moneyNum){
                O1HD.getModules().uiControlModule.showMessageBox("钱不够");
                return false;
            }
            O1HD.getServices().userSrv.setCoins(-moneyNum,true);
        }
        if (choose.param && choose.param.goods && choose.param.goods.length > 0) {
            let goods = choose.param.goods;
            let moneyNum = 0;
            let goodsId = 0;
            let goodsCount = 0;
            for (let o of goods) {
                if (o.coin) {
                    moneyNum += Number(o.coin);
                } else {
                    goodsId = Number(o.id);
                    goodsCount = Number(o.count);
                    
                }
            }
            if(moneyNum > 0){
                if (O1HD.getServices().userSrv.getCoins() < moneyNum) {
                    O1HD.getModules().uiControlModule.showMessageBox("钱不够");
                    return false;
                }
                O1HD.getServices().userSrv.setCoins(-moneyNum,true);
            }

            if (goodsCount > 0) {
                let goodsData = NormalGameManager._instance.getOneGood(goodsId);
                if (!goodsData || goodsData.num < goodsCount) {
                    O1HD.getModules().uiControlModule.showMessageBox("物品不够");
                    return;
                }
                NormalGameManager._instance.onOutGoods(goodsId, goodsCount);
            }
        }
        let chatSp:cc.SpriteFrame = null;
        if(chat.includes("图片：")){
            chatSp = this.spriteMap[ "weChatSprite/" + chat.substring(3)];
        }
        let chatItem:cc.Node = cc.instantiate(this.meAskPrefab);
        let cs = chatItem.getComponent(weChatPrefab);
        let gameManager = NormalGameManager._instance;

        let gameData = gameManager.getGameData();
        let bSaveData = false;
        cs.bindChoose(choose);
        if(chatSp){
            cs.onChat(chatSp,true, choose.watchAdFlag ? choose.watchAdFlag : false );
        }else{
            cs.onChat(
                chat
                , true
                , choose.watchAdFlag ? choose.watchAdFlag : false
                , choose.param
            );
        }
        let meHead = "res/user/head/" + getOneHeadUrlById(NormalGameManager._instance.getGameData().userCurrHead);
        cs.changeHead(this.spriteMap[meHead]);

        let chatSave:WeChatSaveChat = {
            peopleId: this.currentChitChat.peopleId,
            chatsId: this.chitChatId,
            chatId: this.currentChitChat.id,
            chatChoose: chooseIndex,
            bRecv: false,
        }
        this.currentChoose.push(chatSave);
        this.itemContent.addChild(chatItem);
        this.chatScroll.scrollToBottom(.2);
        let param = choose.param;
        
        let addEvent:string = param["addEvent"];

        if(addEvent!=null){
            let ary = NormalGameManager._instance.getGameData().ariseEvent;
            if(!ary.includes(addEvent)){
                ary.push(addEvent);
                NormalGameManager._instance.writeGameData();
            }
        }

        let acCountInfo:{title:string,desc:string,paramsArray:string[],totalFee:number,needPayDays:number}= param["accountInfo"];
        if(acCountInfo){
            let accountItem:AccountItem = {
                uniqueId:NormalGameManager._instance.getGameData().userAccountInfo.length.toString(),
                title : acCountInfo.title,
                desc : acCountInfo.desc,
                paramsArray:acCountInfo.paramsArray,
                totalFee : acCountInfo.totalFee,
                needPayDays : acCountInfo.needPayDays,
                hasPayDays : 0,
                everyDayPay: Math.floor(acCountInfo.totalFee / acCountInfo.needPayDays),
            }
            NormalGameManager._instance.setGameData({ userAccountInfo:[accountItem] },true );
            NormalGameManager._instance.setGameData({ userAccountInfoNewMsg : 1 } , false );
        }

        let coin = param["coin"];
        if(coin){
            O1HD.getServices().userSrv.setCoins(coin,true);
        }

        let spliceOneBankCooperativeId = param["spliceOneBankCooperativeId"];
        if(spliceOneBankCooperativeId!=null){
            NormalGameManager._instance.spliceOneHasBankCooperativeById(spliceOneBankCooperativeId);
        }

        // 延迟时间事件
        let addDelayEvent = param["addDelayEvent"];
        this.delayCallEvent(addDelayEvent);

        // 任务
        let triggerTask = param["triggerTask"];
        this.triggerTask(triggerTask);

        let finishTask = param["finishTask"];
        this.finishTask(finishTask);

        
        let addRecordPoint = param["addRecordPoint"];
        if (addRecordPoint && !gameData.wechatRecordPoint.includes(addRecordPoint)) {
            gameData.wechatRecordPoint.push(addRecordPoint);
            bSaveData = true;
        }

        let linkId = param["WeChatLink"];
        if(linkId!=null){
            if(linkId instanceof Array){
                for(let i = 0;i<linkId.length;i++){
                    gameManager.addOneWeChatTriggerLink(linkId[i]);
                }
            }else{
                gameManager.addOneWeChatTriggerLink(linkId);
            }
            // gameManager.addOneWeChatTriggerLink(linkId);
        }

        let openEvent = param["openEvent"];
        if(openEvent){
            let event = getOneNormalEventNewById(openEvent);
            if(event && event.type == "3"){
                NormalGameManager._instance.addOneEvent(openEvent);
            }
        }

        //恋爱屋
        let loveHouseParam = param["loveHouseParam"];
        if ( loveHouseParam ) {
            if ( loveHouseParam.length == 0 ){
                NormalGameManager._instance.loveStroyManager.addRelation( this.currentChitChat.peopleId );
            }else{
                for ( let itemData of loveHouseParam ) {
                    //添加恋爱屋金额
                    NormalGameManager._instance.loveStroyManager.addOneRecord(
                        itemData.peopleId,
                        itemData.savePeople,
                        itemData.explain,
                        itemData.coin,
                        2,
                        ""
                    );
                }
            }
        }

        //恋爱屋 选项
        let loveHouseChoose : string = param["loveHouseChoose"];
        if ( loveHouseChoose ) {
            NormalGameManager._instance.loveStroyManager.resetOnePeopleOneOptionParam( this.currentChitChat.peopleId , loveHouseChoose ,{});
        }

        //恋爱屋  自动存款选项
        let autoLoveStoryRecord : string = param["autoLoveStoryRecord"];
        if ( autoLoveStoryRecord ) {
            NormalGameManager._instance.loveStroyManager.addOneRule( autoLoveStoryRecord );
        }
        //恋爱屋 监听选项
        let autoLoveStoryListen : string = param["autoLoveStoryListen"];
        if ( autoLoveStoryListen ) {
            NormalGameManager._instance.loveStroyManager.addOneListenRule( autoLoveStoryListen );
        }

        if (bSaveData) {
            NormalGameManager._instance.writeGameData();
        }

        this.scheduleOnce(()=>{
            this.showChooses();
        },1.5);
        return true;
    }

    onOtherChat(chitChat: WeChatChitChat, chooseIndex: number){

        let choose = chitChat.chooses[chooseIndex];
        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        let bSaveData = false;
        let chat:string = choose.chat;
        let chatSp:cc.SpriteFrame = null;
        if(chat.includes("图片：")){
            chatSp = this.spriteMap[ "weChatSprite/" + chat.substring(3)];
        }
        let chatItem:cc.Node = cc.instantiate(this.otherAskPrefab);
        let cs = chatItem.getComponent(weChatPrefab);
        cs.bindChoose(choose);
        if(chatSp){
            cs.onChat(chatSp, false,choose.watchAdFlag ? choose.watchAdFlag : false );
        }else{
            cs.onChat(
                chat
                , false
                , choose.watchAdFlag ? choose.watchAdFlag : false
                , choose.param
            );
        }

        let chatSave:WeChatSaveChat = {
            peopleId: chitChat.peopleId,
            chatsId: this.chitChatId,
            chatId: chitChat.id,
            chatChoose: chooseIndex,
            bRecv: false,
        }

        let people = getOnePeopleById(this.currentChitChat.peopleId);
        cs.changeHead(this.spriteMap[people.headUrl]);
        this.currentChoose.push(chatSave);
        cs.setData(this, this.currentChoose.length-1, false);
        this.itemContent.addChild(chatItem);
        this.chatScroll.scrollToBottom(.2);
        let param = choose.param;

        let addEvent:string = param["addEvent"];
        if(addEvent!=null){
            let ary = NormalGameManager._instance.getGameData().ariseEvent;
            if(!ary.includes(addEvent)){
                ary.push(addEvent);
                bSaveData = true;
            }
        }

        // 延迟时间事件
        let addDelayEvent = param["addDelayEvent"];
        this.delayCallEvent(addDelayEvent);

         // 任务
         let triggerTask = param["triggerTask"];
         this.triggerTask(triggerTask);
         
         let finishTask = param["finishTask"];
         this.finishTask(finishTask);

        let addRecordPoint = param["addRecordPoint"];
        if (addRecordPoint && !gameData.wechatRecordPoint.includes(addRecordPoint)) {
            gameData.wechatRecordPoint.push(addRecordPoint);
            bSaveData = true;
        }

        let linkId = param["WeChatLink"];
        if(linkId!=null){
            if(linkId instanceof Array){
                for(let i = 0;i<linkId.length;i++){
                    gameManager.addOneWeChatTriggerLink(linkId[i]);
                }
            }else{
                gameManager.addOneWeChatTriggerLink(linkId);
            }
        }

        let openEvent = param["openEvent"];
        if(openEvent){
            let event = getOneNormalEventNewById(openEvent);
            if(event && event.type == "3"){
                NormalGameManager._instance.addOneEvent(openEvent);
            }
        }

        //恋爱屋
        let loveHouseParam = param["loveHouseParam"];
        if ( loveHouseParam ) {
            if ( loveHouseParam.length == 0 ){
                NormalGameManager._instance.loveStroyManager.addRelation( this.currentChitChat.peopleId );
            }else{
                for ( let itemData of loveHouseParam ) {
                    //添加恋爱屋金额
                    NormalGameManager._instance.loveStroyManager.addOneRecord(
                        itemData.peopleId,
                        itemData.savePeople,
                        itemData.explain,
                        itemData.coin,
                        2,
                        ""
                    );
                }
            }
        }

        //恋爱屋  选项
        let loveHouseChoose : string = param["loveHouseChoose"];
        if ( loveHouseChoose ) {
            NormalGameManager._instance.loveStroyManager.resetOnePeopleOneOptionParam( this.currentChitChat.peopleId , loveHouseChoose ,{});
        }

        //恋爱屋  自动存款选项
        let autoLoveStoryRecord : string = param["autoLoveStoryRecord"];
        if ( autoLoveStoryRecord ) {
            NormalGameManager._instance.loveStroyManager.addOneRule( autoLoveStoryRecord );
        }
        //恋爱屋 监听选项
        let autoLoveStoryListen : string = param["autoLoveStoryListen"];
        if ( autoLoveStoryListen ) {
            NormalGameManager._instance.loveStroyManager.addOneListenRule( autoLoveStoryListen );
        }

        if (bSaveData) {
            NormalGameManager._instance.writeGameData();
        }
        this.scheduleOnce(()=>{
            let isTrue = this.showChooses();
            // if(isTrue){
            //     this.lastChooseIndex = this.currentChitChats.length;
            //     // console.log(this.currentChitChats,"怎么回事???????????")
            // }
        },1.5);
    }

    delayCallEvent(event: any) {
        if (event) {
            let bCallEvent = true;
            if (utilsModel.isValidNumberValue(event.finishDataType)) {
                switch(event.finishDataType) {
                    /** 是否交付过彩礼 */
                    case 'delayType1': {
                        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
                        bCallEvent = matchMiaiDataManage.matchMiaiData.bBridePrice;
                    } 
                    break;
                }
            }

            if (bCallEvent) {
                NormalGameManager._instance.addDelayTimeEvent(String(event.id), event.delay);
            }
        }
    }

    triggerTask(id: string) {
        if (!utilsModel.isValidNumberValue(id)) {
            return;
        }
        NormalGameManager._instance.taskDataManage.addNewTask(id);
    }

    finishTask(id: string) {
        if (!utilsModel.isValidNumberValue(id)) {
            return;
        }
        NormalGameManager._instance.taskDataManage.addNewFinishTask(id);
    }

    onBtnChoose(e:cc.Event.EventTouch,costm:string){
        let chitChat = this.chitChatMap[this.nextId];
        let index = Number(costm);
        let isTrue = this.onChat(chitChat,index);
        if(isTrue)
        this.chooseNode.active = false;
    }

    async checkIsStart(){
        if(this.isStart){
            // 判断下一段剧情
            let manage = NormalGameManager._instance.weChatManager;
            let isHasNext:boolean = false;
            let peoples = manage.getPeoples();
            for(let i =0;i<peoples.length;i++){
                let p = peoples[i];
                let pChat = p.peopleChatLinkQueue;
                if(pChat.length > 0){
                    isHasNext = true;
                    let chat = p.peopleChatLinkQueue[0];
                    let chatFramePrefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.WeChatGameBundle,"weChat/prefab/WeChatFrame");
                    let chatFrame = cc.instantiate(chatFramePrefab);
                    let cs = chatFrame.getComponent(WeChatFrame);
                    // let chitChat = getOneChitAryById(chat[0]);
                    cs.bindData(chat[0],[],p,this.complete,this.isStart);
                    O1HD.Canvas().addChild(chatFrame);
                    break;
                }
            }
            if(!isHasNext){
                this.complete && this.complete();
            }
        }else{
            this.complete && this.complete();
        }
    }

    async showChooses(){
        if(this.nextId){
            let chitChat = this.chitChatMap[this.nextId];
            // 展示选项
            let peopleId:string = chitChat.peopleId;
            switch(peopleId){
                case "自己":{
                    this.setChoose(chitChat);
                    return true;
                    break;
                }
                default:{
                    this.onChat(chitChat);
                    return false;
                    break;
                }
            }
        }else{
            let last = this.lastWeChatChitChatChoose;
            let lastParam = last.param;
            let isEnd = lastParam["isEnd"];
            if(isEnd!=null){
                let manager = NormalGameManager._instance.weChatManager;
                manager.splitOnePeople(this.weChatLink.people);
                // console.log(this.weChatLink.people,"people??????????")
                // O1HD.emit(WeChatEvent.UPDATEWECHATMAIN);
                O1HD.getModules().uiControlModule.showMessageBox(isEnd);
            }
            let result = lastParam["result"];
            if(result != null){
                this.resultNode.getComponent(WeChatResultNode).bindData(result);
                this.showResultNode();
                if(result == true){
                    this.saveChatData();
                }
            }else{
                //如果存在
                let loveHouseHintStr = lastParam["loveHouseHint"];
                await this.saveChatData();
                if ( loveHouseHintStr != null ) {
                    //如果爱情屋提示内容存在
                    this.congratulationNode.active = true;
                    if ( this.congratulationNode.getChildByName("bindingBg").getChildByName("lbHint") ) {
                        this.congratulationNode.getChildByName("bindingBg").getChildByName("lbHint").getComponent(cc.Label).string = `${loveHouseHintStr}`;
                    }
                }else{
                    this.closeThis();
                }

            }
            return false;
        }
    }

    async saveChatData() {
        if (!this.currentChoose || this.currentChoose.length <= 0) {
            return;
        }
        let manage = NormalGameManager._instance.weChatManager;
        if (!this.nextId) {
            this.people.peopleChatLinkQueue.shift(); 
            // if (this.people.peopleChatLinkQueue.length > 0) {
            //     this.people.bNewChat = true;
            // }
            this.people.bNewChat = true;
        } else {
            this.people.bNewChat = false;
        }
        if (!this.people.peopleChatLastLink) {
            this.people.peopleChatLastLink = [];
        }
        
        this.people.peopleChatLastLink = this.people.peopleChatLastLink.concat(this.currentChoose);
        NormalGameManager._instance.getGameData().finishChatedIdM[this.chitChatId] = 1;
        NormalGameManager._instance.writeGameData();
        manage.writeGameData();
        O1HD.emit(WeChatEvent.UPDATEWECHATMAIN);
        return this.checkIsStart();
    }

    setChoose(chitChat:WeChatChitChat){
        this.chooseNode.active = true;
        let chooses:WeChatChitChatChoose[] = chitChat.chooses;

        if(chooses.length == 1){
            let choose = chooses[0];
            let chat = choose.chat;
            if(chat.includes("图片：")){
                this.chooseNode.active = false;
                this.onChat(chitChat,0);
                return;
            }
        }

        if(chooses.length >=2){
            this.lastChooseIndex = this.currentChitChats.length;
        }

        this.chooseNode.children.forEach((n:cc.Node,index:number)=>{
            let choose = chooses[index];
            if(choose){
                n.active = true;
                let chat = choose.chat;
                if(chat.length > 13){
                    chat = chat.substring(0,13) + "......";
                }
                n.getChildByName("lb").getComponent(cc.Label).string = chat;
            }else{
                n.active = false;
            }
        });
    }

    /**
     * 关闭
     */
    onBtnClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        O1HD.emit("loveStorySharePrefab.showCongratulationsNode");
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    async reStart(){
        this.itemContent.destroyAllChildren();
        this.itemContent.removeAllChildren();

        for (let i = this.oldChoose.length - 1; i >= 0; i--) {
            let o = this.oldChoose[i];
            if (o.chatsId == this.chitChatId) {
                this.oldChoose.splice(i, 1);
            }
        }
        this.people.bNewChat = true;
        if(this.oldChoose.length > 0){
            await this.loadFrame();
        }
        this.startChat();
    }

    alive(){
        //當前有多少個數
        let cCount = this.itemContent.childrenCount;
        //需要刪除的個數
        // let needSpliceCount:number = cCount - this.lastChooseIndex;
        let needSpliceCount:number = 0;

        // console.log(this.currentChitChats.concat(),this.itemContent.childrenCount,needSpliceCount,this.lastChooseIndex);
        let curIdx = 0;
        let bFind = false;
        for (let i = this.currentChoose.length-1; i >= 0; i--) {
            let chatId = this.currentChoose[i].chatId;
            if (this.chitChatMap[chatId].chooses.length >= 2) {
                curIdx = i;
                bFind = true;
                needSpliceCount = this.currentChoose.length - curIdx - 1;
                break;
            }
        }

        if (!bFind) {
            for (let i = this.oldChoose.length-1; i >= 0; i--) {
                let chatId = this.oldChoose[i].chatId;
                if (this.chitChatMap[chatId].chooses.length >= 2) {
                    curIdx = i;
                    bFind = true;
                    needSpliceCount = this.oldChoose.length - curIdx - 1 + this.currentChoose.length;
                    break;
                }
            }

            if (bFind) {
                this.oldChoose.splice(curIdx);
            }
        }
        
        for(let i =0;i<needSpliceCount + 1;i++){
            // if(i<needSpliceCount){
            // }
            this.currentChoose.pop();
            this.currentChitChats.pop();
            let node = this.itemContent.children[cCount - i - 1];
            node.destroy();
            node.removeFromParent();
        }
        if(this.currentChitChats.length >0){
            let next = this.chitChatMap[this.currentChitChats[this.currentChitChats.length - 1].chooses[0].param["nextId"]];
            this.onChat(next);
        }else{
            this.startChat();
        }

    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.saveChatData();
        this.closeThis();
    }

    showResultNode(){
        this.resultNode.active = true;
        let centerNode = this.resultNode.getChildByName("centerNode");
        centerNode.scale = 0;
        cc.tween(centerNode).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
    }

    async loadFrame(){
        let gameManager = NormalGameManager._instance;
        for(let i =0;i<this.oldChoose.length;i++){
            await new Promise<void>(resolve=>{
                let chitChat = this.oldChoose[i];
                let peopleId:string = chitChat.peopleId;
                let prefab :cc.Prefab = null;
                let meHead = "res/user/head/" + getOneHeadUrlById(NormalGameManager._instance.getGameData().userCurrHead);
                let isMe:boolean = false;
                switch(peopleId){
                    case "自己":{
                        prefab = this.meAskPrefab;
                        isMe = true;
                        break;
                    }
                    default:{
                        prefab = this.otherAskPrefab;
                        let people = getOnePeopleById(chitChat.peopleId);
                        meHead = people.headUrl;
                        break;
                    }
                }

                if (!this.chitChatMapMap[chitChat.chatsId]) {
                    this.addChatMap(chitChat.chatsId);
                }
                let chatLink = this.chitChatMapMap[chitChat.chatsId][chitChat.chatId];

                // let chatChoose = this.chitChatMap[chitChat.chatId].chooses[chitChat.chatChoose];
                let chatChoose = chatLink.chooses[chitChat.chatChoose];
                let chat = chatChoose.chat;
                let chatSp:cc.SpriteFrame = null;
                // if(chat.includes("图片：")){
                //     console.log(chat,this.spriteMap["res/weChatSprite/" + chat.substring(3)]);

                // }
                if(chat.includes("图片：")){
                    chatSp = this.spriteMap["res/weChatSprite/" + chat.substring(3)];
                    // this.spriteMap["res/weChatSprite/" + chat.substring(3)]
                }
                let chatItem:cc.Node = cc.instantiate(prefab);
                let cs = chatItem.getComponent(weChatPrefab);
                cs.changeHead(this.spriteMap[meHead]);
                cs.setData(this, i, true);
                this.itemContent.addChild(chatItem);
                this.chatScroll.scrollToBottom(.2);
                if(chatSp){
                    cs.onChat(chatSp,isMe);
                }else{
                    cs.onChat(chat,isMe, false, chatChoose.param, chitChat);
                }
                this.scheduleOnce(resolve);
            });
        }
    }

    recvGoodsSuccess(idx: number, bOldData: boolean) {
        if (bOldData) {
            this.oldChoose[idx].bRecv = true;

            let manage = NormalGameManager._instance.weChatManager;
            this.people.peopleChatLastLink = this.oldChoose.concat();
            manage.writeGameData();
        } else {
            this.currentChoose[idx].bRecv = true;
        }
    }

    lookGoodsAdSuccess(idx: number, bOldData: boolean) {
        if (bOldData) {
            this.oldChoose[idx].bLookAd = true;

            let manage = NormalGameManager._instance.weChatManager;
            this.people.peopleChatLastLink = this.oldChoose.concat();
            manage.writeGameData();
        } else {
            this.currentChoose[idx].bLookAd = true;
        }
    }

    // 跳过剧情
    async onBtnJump(){
        let saveData = ()=>{
            let manage = NormalGameManager._instance.weChatManager;
            this.people.peopleChatLinkQueue.shift();
            if(this.people.peopleChatLinkQueue.length < 1){
                this.people.peopleChatLastLink = this.currentChoose.concat();
            } 
            this.people.bNewChat = true;
            manage.writeGameData();
            O1HD.emit(WeChatEvent.UPDATEWECHATMAIN);
            return this.checkIsStart();
        }

        let startChat = this.chitChatAry[0];
        let chat = startChat;
        let chats:WeChatSaveChat[] = [];
        let gameManager = NormalGameManager._instance;
        while(chat.chooses[0].param["nextId"]!=null){
            let param = chat.chooses[0].param;
            let addEvent:string = param["addEvent"];
            if(addEvent!=null){
                let ary = NormalGameManager._instance.getGameData().ariseEvent;
                if(!ary.includes(addEvent)){
                    ary.push(addEvent);
                    NormalGameManager._instance.writeGameData();
                }
            }
            let linkId = param["WeChatLink"];
            if(linkId!=null){
                if(linkId instanceof Array){
                    for(let i = 0;i<linkId.length;i++){
                        gameManager.addOneWeChatTriggerLink(linkId[i]);
                    }
                }else{
                    gameManager.addOneWeChatTriggerLink(linkId);
                }
            }
            let chatSave:WeChatSaveChat = {
                peopleId: chat.peopleId,
                chatsId: this.chitChatId,
                chatId: chat.id,
                chatChoose: 0,
                bRecv: false,
            }
            chats.push(chatSave);
            chat = this.chitChatMap[param["nextId"]];
        }
        let chatSave:WeChatSaveChat = {
            peopleId: chat.peopleId,
            chatsId: this.chitChatId,
            chatId: chat.id,
            chatChoose: 0,
            bRecv: false,
        }
        chats.push(chatSave);
        let param = chat.chooses[0].param;
        let addEvent:string = param["addEvent"];
        if(addEvent!=null){
            let ary = NormalGameManager._instance.getGameData().ariseEvent;
            if(!ary.includes(addEvent)){
                ary.push(addEvent);
                NormalGameManager._instance.writeGameData();
            }
        }
        let linkId = param["WeChatLink"];
        if(linkId!=null){
            if(linkId instanceof Array){
                for(let i = 0;i<linkId.length;i++){
                    gameManager.addOneWeChatTriggerLink(linkId[i]);
                }
            }else{
                gameManager.addOneWeChatTriggerLink(linkId);
            }
        }
        this.currentChoose = chats.concat();
        await saveData();
        this.closeThis();
    }

}
